import React from "react";
import style from "../../scss/export.module.scss";
import defaultIconSettings from "./defaultIconSettings";

const LogoIcon = ({
    color = style.brandBlueColor,
    size = defaultIconSettings.size,
    className = defaultIconSettings.className,
}) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 600.000000 600.000000"
            style={{ height: size, width: size }}
            className={className}
        >
            <g transform="translate(0.000000,600.000000) scale(0.100000,-0.100000)" fill={color} stroke="none">
                <path
                    d="M0 3695 c0 -1268 2 -2305 4 -2305 1 0 878 655 1947 1455 1069 800
1946 1455 1949 1455 3 0 475 -968 1049 -2150 574 -1183 1045 -2150 1047 -2150
2 0 4 1350 4 3000 l0 3000 -3000 0 -3000 0 0 -2305z"
                />
                <path
                    d="M1805 1887 l-1800 -1312 -3 -288 -2 -287 2650 0 2651 0 -17 32 c-40
79 -1668 3154 -1673 3160 -3 4 -816 -583 -1806 -1305z"
                />
            </g>
        </svg>
    );
};

export default LogoIcon;
